import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { compose } from "ramda";
import VerifyTwoFAForm from "./VerifyTwoFAForm";
import { sendOTP, sendVerificationEmail, verifyOTP } from "../../actions/loginActions";
import AuthLayout from "../common/AuthLayout";

const VerifyTwoFAPage = props => {
  return (
    <AuthLayout {...props}>
      <VerifyTwoFAForm pageName="2-Factor Authentication" onSubmit={props.verifyOTP} {...props} />
    </AuthLayout>
  );
};

VerifyTwoFAPage.propTypes = {
  verifyOTP: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  app: { client, clientName },
  common: { logoUrl },
  login: {
    otp,
    verifyOTPError,
    isOTPSending,
    isOPTVerifying,
    user,
  },
}) => ({
  client,
  logoUrl,
  clientName,
  user,
  validationError: verifyOTPError,
  otp,
  isOTPSending,
  isOPTVerifying,
});

const mapDispatchToProps = {
  sendOTP,
  sendVerificationEmail,
  verifyOTP,
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps))(VerifyTwoFAPage);



// WEBPACK FOOTER //
// ./components/twoFA/VerifyTwoFAPage.js